const nonSemanticListingQueryKeys = new Set([
  'currentUrl',
  'current_url',
  'filters_scope',
  'primary_filters_limit',
  'page',
  'resultsPerPage',
  'order',
  'q',
  'debug',
  '_t',
  'refresh_cache',
])

function hasValue(value: unknown) {
  if (Array.isArray(value)) {
    return value.some(hasValue)
  }

  return value !== undefined && value !== null && value !== ''
}

export function hasSemanticListingFilter(query: Record<string, unknown>) {
  return Object.entries(query).some(([key, value]) => !nonSemanticListingQueryKeys.has(key) && hasValue(value))
}
